import './index.sass';
import 'select2/dist/js/select2.full.min';
import 'select2/dist/css/select2.css';

export default () => {
  if ($('.js-select').length) {
    $('.js-select').each(function () {
      const classAdd = $(this).hasClass('js-select-profile') ? 'select select--profile' : 'select'
      $(this).select2({
        minimumResultsForSearch: -1,
        width: '100%',
        dropdownCssClass: classAdd,
      }).data('select2').$container.addClass('select');
    });
  }
  if ($('.js-select-settings').length) {
    $('.js-select-settings').each(function () {
      $(this).select2({
        minimumResultsForSearch: -1,
        width: '100%',
        placeholder: "Не указано",
        dropdownCssClass: 'select-multiple-dropdown select-multiple-search-dropdown',
      }).data('select2').$container.addClass('select select-settings');
    });
  }
  if ($('.js-select-multiple').length) {
    $('.js-select-multiple').each(function () {
      $(this).select2({
        minimumResultsForSearch: -1,
        width: '100%',
        closeOnSelect : false,
        placeholder: $(this).attr('placeholder'),
        dropdownCssClass: 'select-multiple-dropdown'
      }).data('select2').$container.addClass('select-multiple');
    });
  }
  if ($('.js-select-search-multiple').length) {
    $('.js-select-search-multiple').each(function () {
      I18n.loaded.then(() => {
        $(this).select2({
          width: '100%',
          closeOnSelect : false,
          placeholder: I18n.t('select.choose'),
          dropdownCssClass: 'select-multiple-dropdown select-multiple-search-dropdown'
        }).data('select2').$container.addClass('select-multiple');
      })
    });
  }

  if ($('.js-select-multiple-uploads').length) {
    $('.js-select-multiple-uploads').each(function () {
      I18n.loaded.then(() => {
        $(this).select2({
          width: '100%',
          placeholder: I18n.t('select.choose'),
          dropdownCssClass: 'select-multiple-dropdown',
          maximumSelectionLength: 3,
          language: {
            maximumSelected: function (e) {
              var t = "Вы можете выбрать только " + e.maximum + " элемента";
              return t;
            }
          }
        }).data('select2').$container.addClass('select-multiple');
      })
    });
  }

  if ($('.js-select-messages').length) {
    $('.js-select-messages').each(function () {
      $(this).select2({
        minimumResultsForSearch: -1,
        width: '100%',
        dropdownCssClass: 'select select--messages',
      }).data('select2').$container.addClass('select select-messages');
    });
  }

  const $selectSort = $('.js-select-sort');
  if($selectSort.length) {
    $selectSort.on('change', function() {
      $('#sort_by').val($(this).val());
      $(this).parents('form').submit();
    })
  }

  const $profileSort = $('.js-select-profile');
  if($profileSort.length) {
    $profileSort.on('change', function() {
      $('#order').val($(this).val());
      $(this).closest('form').submit();
    })
  }

}
